// src/components/member-wallet/member-wallet.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletCallToActionLinkFragment on MemberWalletCallToActionLink {\n    __typename\n    icon {\n      id\n    }\n    text\n    action {\n      __typename\n      ... on UILinkAction {\n        target\n        resource {\n          ...MemberWalletCallToActionLinkHttpURIFragment\n        }\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n  }\n  fragment MemberWalletCallToActionLinkHttpURIFragment on HttpURI {\n    value\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletContentFragment on MemberWalletContent {\n    __typename\n    items {\n      ...MemberWalletCallToActionLinkFragment\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletCouponsFragment on MemberWalletCoupons {\n    __typename\n    text\n    label\n    linkAction {\n      resource {\n        __typename\n        ...MemberWalletCouponsHttpURIFragment\n      }\n      analytics {\n        __typename\n        referrerId\n      }\n    }\n  }\n  fragment MemberWalletCouponsHttpURIFragment on HttpURI {\n    relativePath\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletDetailsItemFragment on MemberWalletDetailsItem {\n    __typename\n    mark {\n      url {\n        value\n      }\n      size\n      id\n    }\n    markPosition\n    text\n    label\n    action {\n      __typename\n      ... on UILinkAction {\n        target\n        resource {\n          value\n        }\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletPointsFragment on MemberWalletPoints {\n    __typename\n    text\n    label\n    information {\n      text\n      closeLabel\n    }\n    action {\n      ... on MemberWalletUIAction {\n        analytics {\n          referrerId\n        }\n      }\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletDetailsFragment on MemberWalletDetails {\n    __typename\n    items {\n      ...MemberWalletPointsFragment\n      ...MemberWalletCouponsFragment\n      ...MemberWalletDetailsItemFragment\n    }\n    moreInfo {\n      moreInfoText\n      moreInfoLinkText\n      moreInfoLinkAction {\n        target\n        resource {\n          ...HttpURIFragment\n        }\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n  }\n  fragment HttpURIFragment on HttpURI {\n    value\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletBadgeFragment on MemberWalletBadge {\n    __typename\n    text\n    theme\n    resource {\n      ...MemberWalletBadgeHttpURIFragment\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n  }\n  fragment MemberWalletBadgeHttpURIFragment on HttpURI {\n    relativePath\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletHeadingFragment on MemberWalletHeading {\n    __typename\n    text\n    subText\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment MemberWalletInfoFragment on MemberWalletInfo {\n    __typename\n    items {\n      ...MemberWalletHeadingFragment\n      ...MemberWalletBadgeFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  query MemberWalletQuery($context: ContextInput!) {\n    memberWallet(context: $context) {\n      info {\n        ...MemberWalletInfoFragment\n      }\n      details {\n        ...MemberWalletDetailsFragment\n      }\n      content {\n        ...MemberWalletContentFragment\n      }\n      oneKeyUserEnabled\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
import React10 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { LoyaltyAccountSummaryWidget, LoyaltyExperienceStrategy } from "@shared-ui/retail-loyalty-account-summary";
// src/components/member-wallet/member-wallet-content.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
// src/components/member-wallet/__private/__fragments/components/member-wallet-call-to-action-link.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var fragment = gql(_templateObject());
var MemberWalletCallToActionLink = function (props) {
  var data = props.data;
  var trackClick = useClickTracker();
  var text = data.text,
    action = data.action,
    icon = data.icon;
  if (action.__typename !== "UILinkAction") {
    return null;
  }
  var httpUri = action.resource;
  return /* @__PURE__ */React.createElement(EGDSSpacing, {
    padding: "two"
  }, /* @__PURE__ */React.createElement(EGDSLink, {
    align: "center",
    onClickCapture: function () {
      return trackClick(action.analytics.referrerId, "");
    }
  }, /* @__PURE__ */React.createElement("a", {
    "aria-label": text,
    href: httpUri.value
  }, text, icon && /* @__PURE__ */React.createElement(EGDSIcon, {
    name: icon.id
  }))));
};
MemberWalletCallToActionLink.displayName = "MemberWalletCallToActionLink";
MemberWalletCallToActionLink.fragment = _object_spread_props(_object_spread({}, fragment), {
  __typename: "MemberWalletCallToActionLink"
});
// src/components/member-wallet/member-wallet-content.tsx
var fragment2 = gql2(_templateObject1(), MemberWalletCallToActionLink.fragment);
var contentTypes = [MemberWalletCallToActionLink];
var MemberWalletContent = function (props) {
  var data = props.data;
  if (data.items.length === 0) {
    return null;
  }
  return /* @__PURE__ */React2.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    direction: "column",
    alignItems: "center",
    "data-stid": "member-wallet-content"
  }, data.items.map(function (item, index) {
    var Component = contentTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!Component) {
      return null;
    }
    return /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, {
      key: "member-wallet-content-".concat(index)
    }, /* @__PURE__ */React2.createElement(Component, {
      data: item
    }));
  })));
};
MemberWalletContent.displayName = "MemberWalletContent";
MemberWalletContent.fragment = _object_spread_props(_object_spread({}, fragment2), {
  __typename: "MemberWalletContent"
});
// src/components/member-wallet/member-wallet-details.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
// src/components/member-wallet/__private/__fragments/components/member-wallet-coupons.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment3 = gql3(_templateObject2());
var MemberWalletCoupons = function (props) {
  var data = props.data;
  var trackClick = useClickTracker2();
  if (!data.text) {
    return null;
  }
  var text = data.text,
    label = data.label,
    linkAction = data.linkAction;
  var httpUri = linkAction === null || linkAction === void 0 ? void 0 : linkAction.resource;
  var _httpUri_relativePath;
  return /* @__PURE__ */React3.createElement(EGDSLayoutFlex2, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React3.createElement(EGDSText, {
    size: 500,
    weight: "bold",
    theme: "emphasis"
  }, text), /* @__PURE__ */React3.createElement(EGDSSpacing3, {
    padding: "two"
  }, /* @__PURE__ */React3.createElement(EGDSLink2, {
    onClickCapture: function () {
      var _linkAction_analytics_referrerId;
      return trackClick((_linkAction_analytics_referrerId = linkAction === null || linkAction === void 0 ? void 0 : linkAction.analytics.referrerId) !== null && _linkAction_analytics_referrerId !== void 0 ? _linkAction_analytics_referrerId : "", "");
    }
  }, /* @__PURE__ */React3.createElement("a", {
    "aria-label": label,
    href: (_httpUri_relativePath = httpUri === null || httpUri === void 0 ? void 0 : httpUri.relativePath) !== null && _httpUri_relativePath !== void 0 ? _httpUri_relativePath : "/"
  }, /* @__PURE__ */React3.createElement(EGDSText, {
    size: 300,
    weight: "regular"
  }, label)))));
};
MemberWalletCoupons.displayName = "MemberWalletCoupons";
MemberWalletCoupons.fragment = _object_spread_props(_object_spread({}, fragment3), {
  __typename: "MemberWalletCoupons"
});
// src/components/member-wallet/__private/__fragments/components/member-wallet-details-item.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment4 = gql4(_templateObject3());
var MemberWalletDetailsItem = function (props) {
  var data = props.data;
  var trackClick = useClickTracker3();
  var text = data.text,
    label = data.label,
    action = data.action,
    mark = data.mark,
    markPosition = data.markPosition;
  var LabelComponent = /* @__PURE__ */React4.createElement(EGDSSpacing4, {
    margin: "two"
  }, /* @__PURE__ */React4.createElement(EGDSText2, {
    size: 300,
    weight: "regular"
  }, label));
  if ((action === null || action === void 0 ? void 0 : action.__typename) === "UILinkAction") {
    var analytics = action.analytics,
      resource = action.resource;
    LabelComponent = /* @__PURE__ */React4.createElement(EGDSSpacing4, {
      padding: "two"
    }, /* @__PURE__ */React4.createElement(EGDSLink3, {
      onClickCapture: function () {
        return trackClick(analytics.referrerId, analytics.linkName);
      }
    }, /* @__PURE__ */React4.createElement("a", {
      "aria-label": label,
      href: resource.value
    }, /* @__PURE__ */React4.createElement(EGDSText2, {
      size: 300,
      weight: "regular"
    }, label))));
  }
  return /* @__PURE__ */React4.createElement(EGDSLayoutFlex3, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSLayoutFlex3, {
    space: "two"
  }, markPosition === "LEFT" /* LEFT */ && (mark === null || mark === void 0 ? void 0 : mark.url) && /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSMark, {
    url: mark.url.value,
    size: EGDSMarkSize[mark.size || "small"]
  })), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSText2, {
    size: 500,
    weight: "bold",
    theme: "emphasis"
  }, text)), (markPosition === "RIGHT" /* RIGHT */ || markPosition === void 0) && (mark === null || mark === void 0 ? void 0 : mark.url) && /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSMark, {
    url: mark.url.value,
    size: EGDSMarkSize[mark.size || "small"]
  })))), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, LabelComponent));
};
MemberWalletDetailsItem.displayName = "MemberWalletDetailsItem";
MemberWalletDetailsItem.fragment = _object_spread_props(_object_spread({}, fragment4), {
  __typename: "MemberWalletDetailsItem"
});
// src/components/member-wallet/__private/__fragments/components/member-wallet-points.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
var fragment5 = gql5(_templateObject4());
var MemberWalletPoints = function (props) {
  var data = props.data;
  var text = data.text,
    label = data.label,
    information = data.information,
    action = data.action;
  var _useDialog = _sliced_to_array(useDialog("member-wallet"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var trackClick = useClickTracker4();
  var handleButtonClick = React5.useCallback(function () {
    dialogActions.openDialog();
  }, [dialogActions]);
  var handleDialogFooterButtonClick = React5.useCallback(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  if (!data.text) {
    return null;
  }
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, /* @__PURE__ */React5.createElement(EGDSLayoutFlex4, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React5.createElement(EGDSText3, {
    size: 500,
    weight: "bold",
    theme: "emphasis"
  }, text), action ? /* @__PURE__ */React5.createElement(EGDSTertiaryButton, {
    "aria-label": information.text,
    onClick: handleButtonClick,
    onClickCapture: function () {
      return trackClick(action.analytics.referrerId, "");
    }
  }, /* @__PURE__ */React5.createElement(EGDSText3, {
    size: 300,
    weight: "regular",
    theme: "standard"
  }, label), /* @__PURE__ */React5.createElement(EGDSSpacing5, {
    padding: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React5.createElement(EGDSIcon2, {
    title: "points value information",
    id: label,
    name: "info_outline",
    size: EGDSIconSize.SMALL
  }))) : /* @__PURE__ */React5.createElement(EGDSSpacing5, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React5.createElement(EGDSText3, {
    size: 300,
    weight: "regular",
    theme: "standard"
  }, label))), isDialogOpen && /* @__PURE__ */React5.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React5.createElement(DialogComponent, null, /* @__PURE__ */React5.createElement(EGDSDialog, {
    dialogShow: true,
    returnFocusOnClose: true
  }, /* @__PURE__ */React5.createElement(EGDSDialogContent, null, /* @__PURE__ */React5.createElement("p", null, information.text), /* @__PURE__ */React5.createElement(EGDSDialogFooter, {
    buttonOne: {
      onClick: handleDialogFooterButtonClick,
      text: information.closeLabel,
      type: "tertiary"
    }
  }))))));
};
MemberWalletPoints.displayName = "MemberWalletPoints";
MemberWalletPoints.fragment = _object_spread_props(_object_spread({}, fragment5), {
  __typename: "MemberWalletPoints"
});
// src/components/member-wallet/member-wallet-details.tsx
var detailTypes = [MemberWalletPoints, MemberWalletCoupons, MemberWalletDetailsItem];
var fragment6 = gql6(_templateObject5(), MemberWalletPoints.fragment, MemberWalletCoupons.fragment, MemberWalletDetailsItem.fragment);
var MemberWalletDetails = function (props) {
  var data = props.data;
  var trackClick = useClickTracker5();
  if (data.items.length === 0) {
    return null;
  }
  var moreInfo = data.moreInfo;
  var _ref = moreInfo || {},
    moreInfoText = _ref.moreInfoText,
    moreInfoLinkText = _ref.moreInfoLinkText,
    moreInfoLinkAction = _ref.moreInfoLinkAction;
  var moreInfoLinkActionHttpUri = moreInfoLinkAction === null || moreInfoLinkAction === void 0 ? void 0 : moreInfoLinkAction.resource;
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlex5, {
    direction: "column"
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlex5, {
    direction: "row",
    alignItems: "stretch",
    justifyContent: "space-around",
    "data-stid": "member-wallet-details"
  }, data.items.map(function (item, index) {
    var Component = detailTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!Component) {
      return null;
    }
    return /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem3, {
      key: "member-wallet-details-".concat(index)
    }, /* @__PURE__ */React6.createElement(Component, {
      data: item
    }));
  }))))), moreInfo && /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    margin: {
      inline: "six",
      blockstart: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlex5, {
    direction: "column",
    "data-stid": "member-wallet-details-more-info"
  }, moreInfoText && /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem3, {
    alignSelf: "center"
  }, /* @__PURE__ */React6.createElement(EGDSText4, {
    align: "center",
    "data-stid": "member-wallet-details-more-info-text"
  }, moreInfoText)), moreInfoLinkText && moreInfoLinkAction && moreInfoLinkActionHttpUri && /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem3, {
    alignSelf: "center"
  }, /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    padding: "two"
  }, /* @__PURE__ */React6.createElement(EGDSLink4, {
    align: "center",
    "data-stid": "member-wallet-details-more-info-link",
    onClickCapture: function () {
      return trackClick(moreInfoLinkAction.analytics.referrerId, moreInfoLinkAction.analytics.linkName);
    }
  }, /* @__PURE__ */React6.createElement("a", {
    "aria-label": moreInfoLinkText,
    href: moreInfoLinkActionHttpUri.value
  }, moreInfoLinkText)))))));
};
MemberWalletDetails.displayName = "MemberWalletDetails";
MemberWalletDetails.fragment = _object_spread_props(_object_spread({}, fragment6), {
  __typename: "MemberWalletDetails"
});
// src/components/member-wallet/member-wallet-info.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
// src/components/member-wallet/__private/__fragments/components/member-wallet-badge.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSBadge, EGDSBadgeTheme } from "@egds/react-core/badge";
import { EGDSButton } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var fragment7 = gql7(_templateObject6());
var MemberWalletBadge = function (param) {
  var data = param.data;
  var trackClick = useClickTracker6();
  if (!data.text) {
    return null;
  }
  var text = data.text,
    theme = data.theme;
  var relativePath = data.resource.relativePath;
  return /* @__PURE__ */React7.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React7.createElement(EGDSButton, {
    href: relativePath,
    onClickCapture: function () {
      return trackClick(data.analytics.referrerId, data.analytics.linkName);
    }
  }, /* @__PURE__ */React7.createElement(EGDSBadge, {
    text: text,
    theme: EGDSBadgeTheme[theme]
  })));
};
MemberWalletBadge.displayName = "MemberWalletBadge";
MemberWalletBadge.fragment = _object_spread_props(_object_spread({}, fragment7), {
  __typename: "MemberWalletBadge"
});
// src/components/member-wallet/__private/__fragments/components/member-wallet-heading.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSHeading, EGDSSubheading } from "@egds/react-core/text";
var fragment8 = gql8(_templateObject7());
var MemberWalletHeading = function (props) {
  var data = props.data;
  if (!data.text) {
    return null;
  }
  var text = data.text,
    subText = data.subText;
  return /* @__PURE__ */React8.createElement(EGDSLayoutFlex6, {
    alignItems: "center",
    direction: "column"
  }, text && /* @__PURE__ */React8.createElement(EGDSHeading, {
    tag: "h2",
    size: 5
  }, data.text), subText && /* @__PURE__ */React8.createElement(EGDSSubheading, {
    tag: "h3"
  }, data.subText));
};
MemberWalletHeading.displayName = "MemberWalletHeading";
MemberWalletHeading.fragment = _object_spread_props(_object_spread({}, fragment8), {
  __typename: "MemberWalletHeading"
});
// src/components/member-wallet/member-wallet-info.tsx
var infoTypes = [MemberWalletHeading, MemberWalletBadge];
var fragment9 = gql9(_templateObject8(), MemberWalletHeading.fragment, MemberWalletBadge.fragment);
var MemberWalletInfo = function (props) {
  var data = props.data;
  if (data.items.length === 0) {
    return null;
  }
  return /* @__PURE__ */React9.createElement(EGDSSpacing8, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: "center",
    "data-stid": "member-wallet-info"
  }, data.items.map(function (item, index) {
    var Component = infoTypes.find(function (type) {
      return type.fragment.__typename === item.__typename;
    });
    if (!Component) {
      return null;
    }
    return /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem4, {
      key: "member-wallet-info-".concat(index)
    }, /* @__PURE__ */React9.createElement(Component, {
      data: item
    }));
  })));
};
MemberWalletInfo.displayName = "MemberWalletInfo";
MemberWalletInfo.fragment = _object_spread_props(_object_spread({}, fragment9), {
  __typename: "MemberWalletInfo"
});
// src/components/member-wallet/member-wallet.tsx
var __MemberWalletQuery = gql10(_templateObject9(), MemberWalletInfo.fragment, MemberWalletDetails.fragment, MemberWalletContent.fragment);
var MemberWallet = function (props) {
  var skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var variables = {
    context: context
  };
  var _useQuery = useQuery(__MemberWalletQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading) {
    return /* @__PURE__ */React10.createElement(EGDSLayoutFlex8, {
      justifyContent: "center"
    }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React10.createElement(EGDSLoader, null)));
  }
  if (error || !data) {
    return null;
  }
  if (data.memberWallet.oneKeyUserEnabled) {
    return /* @__PURE__ */React10.createElement(EGDSSpacing9, {
      padding: {
        inline: "three"
      }
    }, /* @__PURE__ */React10.createElement("div", {
      "data-stid": "member-wallet-widget-container"
    }, /* @__PURE__ */React10.createElement(LoyaltyAccountSummaryWidget, {
      inputs: {
        strategy: LoyaltyExperienceStrategy.SHOW_TRAVELER_INFO_AND_REWARDS_LINK,
        viewId: "HeaderView"
      }
    })));
  }
  return /* @__PURE__ */React10.createElement(EGDSLayoutFlex8, {
    direction: "column"
  }, data.memberWallet.info && /* @__PURE__ */React10.createElement(MemberWalletInfo, {
    data: data.memberWallet.info
  }), data.memberWallet.details && /* @__PURE__ */React10.createElement(MemberWalletDetails, {
    data: data.memberWallet.details
  }), data.memberWallet.content && /* @__PURE__ */React10.createElement(MemberWalletContent, {
    data: data.memberWallet.content
  }));
};
MemberWallet.displayName = "sharedui-MemberWallet";
export { MemberWallet };